import { Tool } from '../../types';

export const formTools: Tool[] = [
  {
    id: 'jotform',
    name: 'Jotform',
    category: 'Forms & Surveys',
    description: 'Online form builder and data collection platform',
    pricing: ['free', 'low', 'medium'],
    features: ['ease-of-use', 'integrations', 'mobile'],
    bestFor: ['small-business', 'freelancer'],
    compatibleWith: ['service-business', 'content-creator'],
    goals: ['streamline-operations', 'automate-tasks'],
    industries: ['education', 'marketing', 'consulting'],
    website: 'https://link.jotform.com/btoolme-NbbVn1IuCl',
    imageUrl: 'https://logo.clearbit.com/jotform.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'typeform',
    name: 'Typeform',
    category: 'Forms & Surveys',
    description: 'Conversational forms and surveys with beautiful design',
    pricing: ['free', 'medium'],
    features: ['ease-of-use', 'integrations', 'mobile'],
    bestFor: ['small-business', 'content-creator'],
    compatibleWith: ['marketing', 'service-business'],
    goals: ['enhance-customer-service', 'improve-marketing'],
    industries: ['marketing', 'creative', 'education'],
    website: 'https://www.typeform.com',
    imageUrl: 'https://logo.clearbit.com/typeform.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  }
];